import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";
import classNames from "classnames";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PossessionIndicator from "./PossessionIndicator";
import TimeoutIndicator from "./TimeoutIndicator";
import { useEventContext } from "../../../state/events/context";
import teamSummaryStyles from "../styles/TeamSummary.styles";
import TeamLogo from "../../team/components/TeamLogo";

const TeamSummary = ({
	team,
	reversed,
	hasPossession,
	score,
	timeouts,
	size
}) => {
	const classes = teamSummaryStyles();

	const { state } = useEventContext();
	const timeoutsPerHalf = state.timeoutsPerHalf();
	const { teamName } = team || {};
	const reversedClassName = { [classes.reversed]: !reversed };
	const xsScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));

	return (
		<Grid
			container
			direction={reversed ? "row-reverse" : "row"}
			justifyContent="space-between"
			alignItems="center"
			wrap="nowrap"
			className={classes.container}
			spacing={1}
		>
			<Grid item className={classNames(reversedClassName)}>
				<Typography
					id={`${teamName}-score`}
					className={classNames(classes.scoreText, { small: size === "small" })}
				>
					{score}
				</Typography>
			</Grid>
			<Grid item className={classNames(reversedClassName)}>
				<Grid
					container
					direction={reversed ? "row-reverse" : "row"}
					justifyContent="flex-end"
					alignItems="center"
					wrap="nowrap"
				>
					<Grid item className={classNames(reversedClassName)}>
						<PossessionIndicator teamName={teamName} hasPossession={hasPossession} />
					</Grid>
					{!xsScreen && (
						<Grid
							item
							className={classNames(reversedClassName, classes.teamNameContainer)}
						>
							<Typography
								id={`${teamName}-name`}
								className={classNames(classes.teamNameText, {
									small: size === "small"
								})}
							>
								{teamName}
							</Typography>
							<TimeoutIndicator
								maxTimeouts={timeoutsPerHalf}
								timeouts={timeouts}
								reversed={reversed}
							/>
						</Grid>
					)}
					<Grid item className={classNames(reversedClassName)}>
						<TeamLogo hideName team={team} />
						{xsScreen && (
							<TimeoutIndicator
								maxTimeouts={timeoutsPerHalf}
								timeouts={timeouts}
								reversed={reversed}
							/>
						)}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default TeamSummary;
